import { render } from "./Example3.vue?vue&type=template&id=4234b100"
import script from "./Example3.vue?vue&type=script&lang=ts"
export * from "./Example3.vue?vue&type=script&lang=ts"
script.render = render

export default script